import { Tooltip } from "antd";
import React, { useState } from "react";
import { BarChart2, Eye, List, PieChart } from "react-feather";
import { useToggle } from "../../Utility/modules/helpers";

export const ChartContainer = ({ children }) => {
  const [showLegend, setShowLegend] = useToggle(true);
  const [showLabel, setShowLabel] = useToggle(true);
  const [isDonut, setIsDonut] = useState(true);
  const chartChildren = React.Children.toArray(children);
  const activeChart = isDonut ? chartChildren[0] : chartChildren[1];
  const stopGridDrag = (event) => event.stopPropagation();
  const renderControlButton = (title, onClick, icon) => (
    <Tooltip title={title}>
      <button
        type="button"
        className="chart-container-control"
        onMouseDown={stopGridDrag}
        onTouchStart={stopGridDrag}
        onClick={(event) => {
          event.stopPropagation();
          onClick();
        }}
      >
        {icon}
      </button>
    </Tooltip>
  );

  return (
    <>
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm4 chart-container-controls">
            {renderControlButton(
              "visualize as donut chart...",
              () => setIsDonut(true),
              <PieChart
                color="#6c757d"
                size="16"
              />
            )}{" "}
            {renderControlButton(
              "visualize as column chart...",
              () => setIsDonut(false),
              <BarChart2
                color="#6c757d"
                size="16"
              />
            )}
          </div>
          <div
            className="ms-Grid-col ms-sm8 chart-container-controls"
            style={{ textAlign: "center" }}
          >
            {renderControlButton(
              "show/hide legend",
              setShowLegend,
              <List
                color="#6c757d"
                size="16"
              />
            )}{" "}
            {renderControlButton(
              "show/hide labels",
              setShowLabel,
              <Eye
                color="#6c757d"
                size="16"
              />
            )}{" "}
          </div>
          <div
            className="ms-Grid-col ms-sm4"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              cursor: "pointer",
              padding: "5px",
            }}
          >
            {" "}
          </div>
        </div>
      </div>

      {React.cloneElement(activeChart, {
        key: `${isDonut ? "donut" : "bar"}-${showLegend}-${showLabel}`,
        showLegend,
        showLabel,
      })}
    </>
  );
};

